<script>
import Swal from 'sweetalert2';
import { showMessage } from '@/utils/messages';
import moment from 'moment';
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import KeyWordTag from '@/components/KeywordTag/main.vue';
import TableListComponent from '@/components/TableList/main.vue';
import ButtonActiveFilter from '@/components/ButtonColFilter/main.vue';
import { formatDateCommon } from '@/utils/format';
import { checkPermission } from '@/utils/handlers';

import { lotteryMethods } from '@/state/helpers';

export default {
    page: {
        title: '抽選一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        KeyWordTag,
        TableListComponent,
        ButtonActiveFilter
    },
    data() {
        return {
            listData: [],
            form: {
                form_name: '',
                campaign_name: '',
                source_type: ''
            },
            configKeyword: {
                arrayTag: [],
                placeholder: '抽選タイトル　フォーム名/ファイル名 　キャンペーン名',
                isShowLable: true
            },
            configTable: {
                widthAction: 200,
                headers: [
                    { label: 'ID', width: 100 },
                    { label: '抽選タイトル', width: 300 },
                    { label: 'フォーム名/ファイル名', width: 300 },
                    { label: 'キャンペーン名', width: 300 },
                    { label: '内部/外部', width: 100 },
                    { label: '作成日時', width: 150 }
                ]
            },
            configPage: {
                total: 0,
                limit: 10,
                page: 1
            },
            checkShowFilter: false,
            isLoading: false,
            isActive: true,
            heightSizeTable: ''
        };
    },
    methods: {
        ...lotteryMethods,
        formatDateCommon,
        checkPermission,
        formatDate(date) {
            if (!date) return '';
            return moment(date).locale('ja').format('YYYY年M月D日（ddd） HH:mm:ss');
        },
        doDeleteLottery(item) {
            Swal.fire({
                title: '抽選を削除します。よろしいですか？',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#e8ecf4',
                cancelButtonText: 'キャンセル',
                confirmButtonText: 'OK'
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const res = await this.deleteLottery(item.id);
                        if (res) {
                            showMessage(200, this.$bvToast, '削除しました');
                            this.getList();
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
            });
        },
        handleShowFilter() {
            this.checkShowFilter = !this.checkShowFilter;
        },
        goToEdit(path, item) {
            this.$router.push({ path: path, query: { id: item.id } });
        },
        getQueryString() {
            let query = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[id]=desc`];
            if (this.checkShowFilter) {
                if (this.form.form_name) query.push(`search[form_name]=${encodeURIComponent(this.form.form_name)}`);
                if (this.form.campaign_name) query.push(`search[campaign_name]=${encodeURIComponent(this.form.campaign_name)}`);
                if (this.form.source_type) query.push(`filters[source_type]=${encodeURIComponent(this.form.source_type)}`);
            } else {
                if (this.configKeyword.arrayTag.length > 0) {
                    query.push(`q=${this.configKeyword.arrayTag.toString()}`);
                }
            }
            return query.join('&');
        },
        getList() {
            this.isLoading = true;
            let query = this.getQueryString();
            this.listLottery(query)
                .then((data) => {
                    this.listData = data.data || [];
                    if (data._metadata) {
                        this.configPage.total = data._metadata.total;
                        this.configPage.limit = data._metadata.limit * 1;
                    }
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        search() {
            this.getList();
        },
        clear() {
            this.form = {
                form_name: '',
                campaign_name: '',
                source_type: ''
            };
            this.configKeyword.arrayTag = [];
            this.getList();
        }
    },
    mounted() {
        if (this.$route.query.created) {
            showMessage(200, this.$bvToast, '抽選が作成されました。');
            this.$router.replace({ path: '/lottery/list' });
        }
        this.getList();
    }
};
</script>

<template>
    <Layout>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header d-flex" style="gap: 0.5rem">
                        <h3 class="mb-0 title--screen">抽選検索</h3>
                        <div class="ml-auto">
                            <ButtonActiveFilter
                                :active.sync="isActive"
                                @sizeHeight="(height) => (heightSizeTable = height)"
                                :smallCol="577"
                                :largeCol="53.9"
                            />
                        </div>
                    </div>
                    <div v-if="isActive" class="card-body position-relative">
                        <div class="row justify-content-center">
                            <div class="col-sm-6 position-static">
                                <form class="needs-validation" autocomplete="off">
                                    <div v-if="!checkShowFilter" class="row form-group">
                                        <div class="col-sm-12">
                                            <KeyWordTag :keyword="form.keywords" :config="configKeyword" class="flex-fill" />
                                        </div>
                                    </div>
                                    <div v-if="checkShowFilter">
                                        <div class="form-group row">
                                            <label class="col-sm-3" for="validationCustom01">フォーム名/ファイル名 </label>
                                            <div class="col-sm-9">
                                                <input id="validationCustom01" v-model="form.form_name" type="text" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-3" for="validationCustom02">キャンペーン名</label>
                                            <div class="col-sm-9">
                                                <input id="validationCustom02" v-model="form.campaign_name" type="text" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="form-group row align-items-center">
                                            <label class="col-sm-3">内部/外部</label>
                                            <div class="col-sm-9">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input
                                                        type="radio"
                                                        id="source_type_all"
                                                        value=""
                                                        v-model="form.source_type"
                                                        class="custom-control-input"
                                                    />
                                                    <label class="custom-control-label" for="source_type_all">すべて</label>
                                                </div>
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input
                                                        type="radio"
                                                        id="source_type_internal"
                                                        value="form"
                                                        v-model="form.source_type"
                                                        class="custom-control-input"
                                                    />
                                                    <label class="custom-control-label" for="source_type_internal">内部</label>
                                                </div>
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input
                                                        type="radio"
                                                        id="source_type_external"
                                                        value="external"
                                                        v-model="form.source_type"
                                                        class="custom-control-input"
                                                    />
                                                    <label class="custom-control-label" for="source_type_external">外部</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="text-center mt-4">
                                        <button type="button" @click="clear()" class="btn btn-common btn-outline-primary">
                                            <i class="ri-restart-line"></i>{{ $t('btn.clear') }}
                                        </button>
                                        <button type="button" @click="search()" class="btn btn-common btn-primary ml-3">
                                            <i class="ri-search-line"></i>{{ $t('btn.search') }}
                                        </button>
                                        <button type="button" @click="handleShowFilter" class="btn btn-common filter btn-outline-primary">
                                            <i class="ri-equalizer-line"></i>絞り込み条件を表示
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-0">
                    <div class="card-header">
                        <h3 class="mb-0 title--screen">
                            抽選一覧 <span>件数（{{ configPage.total }})</span>
                        </h3>
                    </div>
                    <div class="card-body">
                        <TableListComponent
                            :heightTable="heightSizeTable"
                            :config="configTable"
                            :dataList="listData"
                            :isLoading="isLoading"
                            :configPage.sync="configPage"
                            :stickyAction="true"
                            @onChangePage="getList()"
                        >
                            <template #row="{ row }">
                                <tr @dblclick="goToEdit('/lottery/edit', row)">
                                    <td>
                                        <div class="el-table__cell text-left">{{ row.id }}</div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left">{{ row.title }}</div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left">{{ row.form_name }}</div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left">{{ row.campaign_name }}</div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left">{{ row.source_type === 'form' ? '内部' : '外部' }}</div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left">{{ formatDateCommon(row.created_at, 'dateTimeJP') }}</div>
                                    </td>
                                    <td class="sticky_action text-left" style="z-index: 15">
                                        <div class="el-table__cell text-left">
                                            <a
                                                v-if="checkPermission('lottery.edit')"
                                                href="javascript:void(0)"
                                                class="btn btn-common-sml btn-primary mr-2"
                                                @click="goToEdit('/lottery/edit', row)"
                                                ><i class="ri-edit-box-line"></i>編集</a
                                            >
                                            <a
                                                v-if="checkPermission('lottery.delete')"
                                                href="javascript:void(0)"
                                                class="btn btn-common-sml btn-danger"
                                                @click="doDeleteLottery(row)"
                                                ><i class="ri-delete-bin-line"></i>削除</a
                                            >
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </TableListComponent>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
